import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

const constructEndpoint = (baseUrl: string, projectId: number, requestAlias: string) =>
	`${baseUrl}/rest/servicedesk/onboarding/1/create-demo-requests/${projectId}/${requestAlias}`;

export const post = (baseUrl: string, projectId: number, requestAlias: string): Promise<void> => {
	const url = constructEndpoint(baseUrl, projectId, requestAlias);
	return performPostRequest(url);
};
